import React from "react";

interface ProdutorProps {
  onOpenModal: () => void;
}

const Icon: React.FC<{ path: string }> = ({ path }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d={path} />
  </svg>
);

const recursos = [
  {
    titulo: "O catálogo do seu parceiro no celular",
    texto:
      "Produto por produto, com o preço de cada embalagem, a quantidade mínima, o frete CIF ou FOB e a janela de entrega. O preço vem do sistema do parceiro, não de tabela antiga.",
    icon: "M3 4.5h14M3 4.5v11h14v-11 M7 8.5h6M7 11.5h4",
    destaque: true,
  },
  {
    titulo: "Compra na hora",
    texto:
      "Escolheu a embalagem, põe no carrinho e fecha. O total aparece antes de você confirmar.",
    icon: "M2.5 3.5h2l2 9h9 M6.5 9.5h9l1.5-5h-12 M7.5 16a1 1 0 100-2 1 1 0 000 2z M14.5 16a1 1 0 100-2 1 1 0 000 2z",
  },
  {
    titulo: "Ofertas do dia",
    texto: "O que os parceiros colocaram em promoção hoje, reunido em uma tela.",
    icon: "M10 2.5l2.2 4.8 5.3.6-3.9 3.6 1 5.2-4.6-2.6-4.6 2.6 1-5.2L2.5 7.9l5.3-.6z",
  },
  {
    titulo: "Pedido em tempo real",
    texto:
      "Aprovado, itens em separação, a caminho, entregue. Muda no parceiro, muda na sua tela.",
    icon: "M10 2.5a7.5 7.5 0 107.5 7.5H10z M10 2.5v7.5",
  },
  {
    titulo: "Conversa com o parceiro",
    texto:
      "Dúvida sobre embalagem, prazo ou frete resolve no chat, dentro do pedido, sem sair do app.",
    icon: "M3 5.5A1.5 1.5 0 014.5 4h11A1.5 1.5 0 0117 5.5v6a1.5 1.5 0 01-1.5 1.5H8l-4 3.5v-3.5H4.5A1.5 1.5 0 013 11.5z",
  },
  {
    titulo: "Suas fazendas cadastradas",
    texto:
      "Cada propriedade com inscrição, cidade e roteiro. O endereço de entrega já vai preenchido no pedido.",
    icon: "M10 17.5s6-4.6 6-9a6 6 0 10-12 0c0 4.4 6 9 6 9z M10 6.5a2 2 0 100 4 2 2 0 000-4z",
  },
  {
    titulo: "Pagamento no app",
    texto:
      "PIX, boleto ou cartão. Parcelamento quando o parceiro oferece, e o comprovante fica no pedido.",
    icon: "M2.5 6.5h15v8h-15z M2.5 9.5h15",
  },
  {
    titulo: "Devolução pelo app",
    texto:
      "Chegou errado ou danificado: você abre a solicitação, anexa foto e acompanha a resposta.",
    icon: "M3.5 8.5h9a4 4 0 110 8H8 M3.5 8.5l3.5-3.5M3.5 8.5L7 12",
  },
  {
    titulo: "Favoritos e busca",
    texto: "Salve o que você repõe sempre e ache por categoria ou por parceiro.",
    icon: "M8.5 13.5a5 5 0 100-10 5 5 0 000 10z M12.5 12.5l4.5 4.5",
  },
  {
    titulo: "Cotação quando falta no catálogo",
    texto:
      "Produto que nenhum parceiro publicou ainda: você pede cotação e eles respondem com preço.",
    icon: "M3 5h14M3 10h14M3 15h9",
  },
  {
    titulo: "Entrada por biometria",
    texto: "Digital ou reconhecimento facial para abrir o app.",
    icon: "M6 16.5c-1-1.5-1.5-3.5-1.5-6.5a5.5 5.5 0 0111 0c0 3-.5 5-1.5 6.5 M10 7.5v6",
  },
];

const Produtor: React.FC<ProdutorProps> = ({ onOpenModal }) => (
  <section id="produtor" className="border-b border-bone-300 bg-white">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <div className="flex flex-wrap items-end justify-between gap-8">
        <div className="max-w-2xl">
          <p className="eyebrow">Para quem produz</p>
          <h2 className="mt-4 font-display text-display-md font-bold text-soil">
            A compra inteira
            <br />
            cabe no celular.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-soil/75">
            O app foi feito para quem está na fazenda e precisa comprar bem sem
            passar o dia no telefone.
          </p>
        </div>
        <button onClick={onOpenModal} className="cta-solid">
          Quero o app
        </button>
      </div>

      <div className="mt-12 grid gap-px border border-bone-300 bg-bone-300 sm:grid-cols-2 lg:grid-cols-3">
        {recursos.map((r) => (
          <article
            key={r.titulo}
            className={`p-6 lg:p-7 ${r.destaque ? "bg-soy/10 sm:col-span-2" : "bg-white"}`}
          >
            <span
              className={`inline-flex h-9 w-9 items-center justify-center rounded-lg ${
                r.destaque ? "bg-soy text-soil" : "bg-agro-lighter text-agro-primary"
              }`}
            >
              <Icon path={r.icon} />
            </span>
            <h3
              className={`mt-4 font-display font-bold text-soil ${
                r.destaque ? "text-xl" : "text-base"
              }`}
            >
              {r.titulo}
            </h3>
            <p
              className={`mt-2 leading-relaxed text-soil/70 ${
                r.destaque ? "max-w-xl text-base" : "text-sm"
              }`}
            >
              {r.texto}
            </p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Produtor;
